import { Button, Stack, Typography } from '@mui/material';
import { CheckCircleIcon } from 'assets';
import ModalUI from 'components/common/ModalUI';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'routers/routes';

interface AcceptExtensionReductionModalProps {
  onClose: () => void;
}

export function PopupThankYouPurchase({
  onClose,
}: AcceptExtensionReductionModalProps) {
  const redirect = useNavigate();
  const backToCredits = () => {
    onClose();
    redirect(APP_ROUTES.CREDITS.OVERVIEW.to);
  };

  return (
    <ModalUI
      open
      onClose={onClose}
      hideCloseButton
      forceAction
      PaperProps={{
        sx: { maxWidth: 500, height: 'unset', margin: 3, borderRadius: 2 },
      }}
    >
      <Stack spacing={3} justifyContent={'center'} alignItems={'center'}>
        <Stack spacing={2} alignItems={'center'}>
          <CheckCircleIcon color="primary" sx={{ width: 55, height: 55 }} />
          <Typography variant="Web_Title_18" color="primary.main">
            Successful Payment
          </Typography>
        </Stack>
        <Typography
          textAlign={'center'}
          fontSize={14}
          fontWeight={700}
          color={'text.secondary'}
        >
          Thank you for your purchase!
          <br /> Please note the following:
        </Typography>
        <Stack spacing={3}>
          <Typography variant="Web_Label_14">
            ✅ You can only purchase a new package after fully utilizing your
            current one.
          </Typography>
          <Typography variant="Web_Label_14">
            ⏳ Packages are valid for 6 months from the date of purchase.
          </Typography>
          <Typography variant="Web_Label_14">
            💳 If you have insufficient credits for a booking, you will need to
            top up at your current package rate before proceeding.
          </Typography>
          <Typography variant="Web_Label_14">
            For any questions, feel free to reach out to our support team. Happy
            booking! 😊
          </Typography>
        </Stack>
        <Button variant="contained" onClick={backToCredits}>
          Back to Credits
        </Button>
      </Stack>
    </ModalUI>
  );
}

export default PopupThankYouPurchase;
